import React from "react";
import { Row, Col } from "react-bootstrap";

function MonthlyPercentage(props) {
	return (
		<>
			{props && (
				<Row className="weekly-hours mt-2">
					<Col className="last-week-hours">
						<h6>Last Month Work From Office</h6>
						<div className="last-week">
							{props.lastweekHours &&
							props.lastweekHours != "00:00"
								? Number(props.lastweekHours)?.toFixed(1) + "%"
								: "0%"}
						</div>
					</Col>
					<Col className="current-week-hours">
						<h6>Current Month Work From Office</h6>
						<div className="curr-week">
							{props.currentWeekHours &&
							props.currentWeekHours != "00:00"
								? Number(props.currentWeekHours)?.toFixed(1) +
								  "%"
								: "0%"}
						</div>
					</Col>
					<Col className="total-hours">
						<h6>Total Work From Office</h6>
						<div className="curr-month">
							{props.totalhours != "00:00" &&
							props.totalhours != null &&
							props.totalhours != 0
								? Number(props.totalhours)?.toFixed(1) + "%"
								: "0"}
						</div>
					</Col>
				</Row>
			)}
		</>
	);
}

export default MonthlyPercentage;
